import colors from 'styles/colors'

const styles = {
  section: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 92,
    paddingBottom: 180,
    width: 320,
    margin: '0 auto'
  },
  dateTimeSelected: {
    marginBottom: 18,
    color: colors.primary,
    fontFamily: 'Barlow',
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: '18px',
    textAlign: 'center',
    letterSpacing: '1.17px',
    textTransform: 'uppercase'
  }
}

export default styles
